import axios, { type AxiosResponse } from "axios";
import { queryParams } from "../../../utils/queryParams";
import type {
  DelayedJobRecord,
  ListParams,
  ListPayload,
  OverviewPayload,
  QueueParams
} from "./types";

const instance = axios.create({
  baseURL: queryParams.apiVersion
});

export const api = {
  getList(params: ListParams = { status: "enqueued", page: 1, per_page: 20 }): Promise<
    AxiosResponse<ListPayload>
  > {
    return instance.get("admin/delayed_jobs", { params });
  },

  getOverview(params: QueueParams = {}): Promise<AxiosResponse<OverviewPayload>> {
    return instance.get("admin/delayed_jobs/overview", { params });
  },

  getJob(id: number): Promise<AxiosResponse<DelayedJobRecord>> {
    return instance.get(`admin/delayed_jobs/${id}`);
  },

  destroyJob(id: number): Promise<AxiosResponse<{ id: number; deleted: boolean }>> {
    return instance.delete(`admin/delayed_jobs/${id}`);
  },

  requeueJob(id: number): Promise<AxiosResponse<DelayedJobRecord>> {
    return instance.post(`admin/delayed_jobs/${id}/requeue`);
  },

  reloadJob(id: number): Promise<AxiosResponse<DelayedJobRecord>> {
    return instance.post(`admin/delayed_jobs/${id}/reload`);
  },

  requeueFailed(params: QueueParams = {}): Promise<AxiosResponse<{ updated_count: number }>> {
    return instance.post("admin/delayed_jobs/requeue_failed", null, { params });
  },

  requeuePending(params: QueueParams = {}): Promise<AxiosResponse<{ updated_count: number }>> {
    return instance.post("admin/delayed_jobs/requeue_pending", null, { params });
  },

  clearFailed(params: QueueParams = {}): Promise<AxiosResponse<{ deleted_count: number }>> {
    return instance.delete("admin/delayed_jobs/clear_failed", { params });
  }
};
